import React from "react";

import { Col, Row, Typography, Layout, Card, Image, Button } from "antd";
import { ImageUrl } from "../../helpers/Functions";
import { useNavigate } from "react-router";
import "./courses-page.css";

const items = [
  // {
  //   title: "B2B Customer Portals",
  //   image: "new-31.png",
  //   link: "/b2bPortal",
  // },
  {
    title: "B2B Training",
    image: "new-51.png",
    link: "/b2bTraining",
  },
  // {
  //   title: "Compliance Training",
  //   image: "new-66.png",
  //   link: "/complianceTraining",
  // },
  // {
  //   title: "Continuing Education",
  //   image: "new-60.png",
  //   link: "/continuingEducation",
  // },
  {
    title: "Course Integration APi",
    image: "new-45.png",
    link: "/courceintegrationAPi",
  },
  {
    title: "Customer Stories",
    image: "new-90.png",
    link: "/CustomerStories",
  },
  {
    title: "Customer Training",
    image: "new-56.png",
    link: "/customerTraining",
  },
  {
    title: "Employee Development",
    image: "new-78.png",
    link: "/employeeDevelopment",
  },
  {
    title: "Flexible Ecommerce",
    image: "new-22.png",
    link: "/flexibleEcommerce",
  },
  {
    title: "Instructor Led Training",
    image: "new-10.png",
    link: "/instructorLedTraining",
  },
  {
    title: "Learner Reports",
    image: "new-18.png",
    link: "/learnerReports",
  },
  // {
  //   title: "Pricing Plans",
  //   image: "new-89.png",
  //   link: "/pricingPlans",
  // },
  // {
  //   title: "Self Paced Course",
  //   image: "new-4.png",
  //   link: "/selfPacedCourse",
  // },
  // {
  //   title: "Visual Branding",
  //   image: "new-39.png",
  //   link: "/visualBranding",
  // },
  // Add more items as needed
];

function AboutUs() {
  const navigate = useNavigate();
  return (
    <Layout className="courses-page" style={{ minHeight: "100vh" }}>
      <Row
        className="blueBackground-old servicebnr courses-hero"
        justify="center"
        style={{
          height: "45vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="courses-hero-panel">
          <Typography.Text className="courses-hero-kicker">WrightCo Academy</Typography.Text>
          <Typography.Title className="courses-hero-title fontFamily1" level={1}>
            Services
          </Typography.Title>
        </div>
      </Row>

      <Row className="whiteBackground courses-main" justify="center">
        <Col xs={24} md={22} lg={21} className="courses-main-inner">
          <Row
            className="gutter-0 courses-grid"
            justify="center"
            align="stretch"
            gutter={[24, 28]}
          >
            {items?.map((item, index) => (
              <Col xs={24} sm={12} md={12} lg={8} key={index} className="courses-grid-col">
                <Card
                  className="populr-card courses-service-card"
                  cover={
                    <Image
                      preview={false}
                      alt={item.title}
                      src={ImageUrl(item.image)}
                    />
                  }
                >
                  <h5>{item.title}</h5>
                  <div className="courses-card-actions">
                    <Button
                      type="primary"
                      htmlType="button"
                      className="loginButton"
                      onClick={() => navigate(item.link)}
                      block
                    >
                      View Details
                    </Button>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </Layout>
  );
}

export default AboutUs;
